'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _helpers = require('../../../../helpers/');

var _RuleBranch = require('./RuleBranch');

var _RuleBranch2 = _interopRequireDefault(_RuleBranch);

require('./RuleLogic.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RuleLogic = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(RuleLogic, _React$Component);

  function RuleLogic() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RuleLogic);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RuleLogic.__proto__ || (0, _getPrototypeOf2.default)(RuleLogic)).call.apply(_ref, [this].concat(args))), _this), _this.showAddRuleBranchText = {
      IF: "If these conditions are met",
      ELSEIF: "Alternatively If",
      ELSE: "Otherwise"
    }, _this.availableActions = {
      actions: {
        ruleBranch: {
          remove: function remove(id) {
            _this.props.ruleDetailsActions('removeRuleBranch', id);
          },
          update: function update(id, updates) {
            _this.props.ruleDetailsActions('updateRuleBranch', id, updates);
          }
        },
        conditionGroup: {
          add: function add(ruleBranchID) {
            _this.props.ruleDetailsActions('addConditionGroup', ruleBranchID);
          },
          remove: function remove(ruleBranchID, id) {
            _this.props.ruleDetailsActions('removeConditionGroup', ruleBranchID, id);
          },
          update: function update(id, ruleBranchID, updates) {
            _this.props.ruleDetailsActions('updateConditionGroup', id, ruleBranchID, updates);
          }
        },
        condition: {
          add: function add(conditionGroupID, ruleBranchId) {
            _this.props.ruleDetailsActions('addCondition', conditionGroupID, ruleBranchId);
          },
          update: function update(id, conditionGroupID, ruleBranchId, updates) {
            _this.props.ruleDetailsActions('updateCondition', id, conditionGroupID, ruleBranchId, updates);
          },
          edit: function edit(id) {
            _this.props.ruleDetailsActions('editEntity', id, 'conditions', true);
          },
          cancelEdit: function cancelEdit(id) {
            _this.props.ruleDetailsActions('editEntity', id, 'conditions', false);
          },
          remove: function remove(id, conditionGroupID, ruleBranchId) {
            _this.props.ruleDetailsActions('removeCondition', id, conditionGroupID, ruleBranchId);
          },
          fetchLocations: function fetchLocations(query, successCallback, errorCallback) {
            _this.props.ruleDetailsActions('fetchLocations', query, successCallback, errorCallback);
          }
        },
        task: {
          add: function add(ruleBranchId) {
            _this.props.ruleDetailsActions('addTask', ruleBranchId);
          },
          remove: function remove(ruleBranchId, id) {
            _this.props.ruleDetailsActions('removeTask', ruleBranchId, id);
          },
          edit: function edit(id) {
            _this.props.ruleDetailsActions('editEntity', id, 'tasks', true);
          },
          cancelEdit: function cancelEdit(id) {
            _this.props.ruleDetailsActions('editEntity', id, 'tasks', false);
          },
          update: function update(id, ruleBranchID, updates) {
            _this.props.ruleDetailsActions('updateTask', id, ruleBranchID, updates);
          }
        }
      }
    }, _this.renderAddRuleBranchButton = function (clauseIntro) {
      return _react2.default.createElement(
        _antd.Button,
        {
          type: 'dashed',
          className: 'new-rule-branch-button',
          onClick: function onClick() {
            _this.props.ruleDetailsActions('addRuleBranch', clauseIntro);
          },
          key: 'add-rule-branch-' + clauseIntro.toLowerCase()
        },
        '+ ',
        _this.showAddRuleBranchText[clauseIntro]
      );
    }, _this.renderBranches = function () {
      var ruleBranches = _this.props.ruleBranches;

      var ruleBranchesRender = [];

      // Render all rule branches
      ruleBranches.forEach(function (ruleBranch, ruleBranchIndex) {
        ruleBranchesRender.push(_react2.default.createElement(_RuleBranch2.default, {
          key: 'rule-branch-' + ruleBranch.id,
          ruleBranch: ruleBranch,
          options: _this.availableActions,
          editingConditions: _this.props.editing.conditions,
          meta: _this.props.meta,
          editingTasks: _this.props.editing.tasks,
          ruleSettings: _this.props.ruleSettings,
          users: _this.props.users,
          builderActions: _this.props.builderActions,
          invalidEntities: _this.props.invalidEntities
        }));
        // If this is the last rule branch for the specific clauseIntro, display button to add another rule branch
        if (ruleBranch.showAddRuleBranch) {
          ruleBranchesRender.push(_this.renderAddRuleBranchButton(ruleBranch.clauseIntro));
        }
      });

      // If we do not have any ELSEIF rule branches, display button to add
      if ((0, _helpers.getRuleBranchesByType)(ruleBranches, "ELSEIF").length === 0) {
        if ((0, _helpers.getRuleBranchesByType)(ruleBranches, "ELSE").length !== 0) {
          // Insert as second last element
          ruleBranchesRender.splice(ruleBranchesRender.length - 1, 0, _this.renderAddRuleBranchButton("ELSEIF"));
        } else {
          ruleBranchesRender.push(_this.renderAddRuleBranchButton("ELSEIF"));
        }
      }
      // If we do not have any ELSE rule branches, display button to add
      if ((0, _helpers.getRuleBranchesByType)(ruleBranches, "ELSE").length === 0) {
        ruleBranchesRender.push(_this.renderAddRuleBranchButton("ELSE"));
      }

      return ruleBranchesRender;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RuleLogic, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'ruleLogic__component' },
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            { span: 24 },
            this.renderBranches()
          )
        )
      );
    }
  }]);
  return RuleLogic;
}(_react2.default.Component), _class.propTypes = {
  ruleDetailsActions: _propTypes2.default.func.isRequired,
  ruleBranches: _propTypes2.default.arrayOf(_RuleBranch2.default.propTypes.ruleBranch).isRequired,
  editing: _propTypes2.default.shape({
    conditions: _RuleBranch2.default.propTypes.editingConditions,
    tasks: _RuleBranch2.default.propTypes.editingTasks
  }).isRequired,
  meta: _propTypes2.default.shape(_RuleBranch2.default.propTypes.meta).isRequired,
  ruleSettings: _propTypes2.default.shape(_RuleBranch2.default.propTypes.ruleSettings).isRequired,
  users: _propTypes2.default.shape(_RuleBranch2.default.propTypes.users).isRequired,
  invalidEntities: _propTypes2.default.shape(_RuleBranch2.default.propTypes.invalidEntities).isRequired,
  builderActions: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = RuleLogic;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Builder/components/RuleLogic.js
// module id = 3780
// module chunks = 4